
/* injects from baggage-loader */

'use strict';

export default function (app) {

	app.constant('APP_VERSION', '1.3.0');
	app.constant('DEFAULT_PAGE_TITLE', 'Machine Document');

	app.constant('ROOT_URL', '{{root_url}}');
	app.constant('FILE_UPLOAD_URL', 'https://storage-qa.machinedocument.com/upload');
	app.constant('DOWNLOAD_URL', 'dl-qa.machinedocument.com');
	app.constant('SCAN_URL', 'scan-qa.machinedocument.com');
	app.constant('GROUPS_URL', 'groups-qa.machinedocument.com');
	app.constant('SERVICES_URL', 'services-qa.machinedocument.com');

	app.constant('MAPBOX_ACCESS_TOKEN', 'pk.eyJ1IjoibWl0Y2hza29tcmEiLCJhIjoiY2pqOG53Ymk1MG5mZjNwcDJzN3Y4ZHAwdSJ9.0pCByOO8hndAByxj94LuIg');
}


// WEBPACK FOOTER //
// ./src/app/core/constants.js